/* Sign selector — homepage chooser and element-page sign picker.
   Loaded once per page; boots every .sgs section it finds.

   Element page: once a sign is chosen the three-plate chooser is replaced by
   a hero for that sign — plate on the left, name, dates and the four kits on
   the right. On a fresh arrival the plate is traced in line by line, big and
   centred in the viewport, then settles into its slot, and ONLY THEN do the
   details stagger in — while the plate is big or moving it covers the details
   column, so nothing may show there until it has landed. "Change sign" brings
   the chooser back.

   The draw-in reads the plate's pixels, so the <img> must carry
   crossorigin="anonymous" — Shopify's CDN allows it. */
(function () {
  if (window.__nytSignSelector) return;
  window.__nytSignSelector = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var GLIDE_MS = 700; // must match the .sgs-chosen-plate transform transition

  function bootHub(root) {
    var pathTabs = root.querySelectorAll('.sgs-path[role="tab"]');
    pathTabs.forEach(function (t) {
      t.addEventListener('click', function () {
        pathTabs.forEach(function (o) {
          var on = o === t;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          o.classList.toggle('sgs-path--on', on);
          var p = document.getElementById(o.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      });
    });
    root.querySelectorAll('.sgs-sign').forEach(function (a) {
      a.addEventListener('click', function () {
        try { sessionStorage.setItem('nyt-sign', a.dataset.sign); } catch (e) {}
      });
    });
  }

  /* Trace the plate's edges in gold over ~2s (marching squares, six lanes),
     then resolve. Any wheel/touch/key skips to the end. Returns a cancel fn. */
  function trace(plate, img, done) {
    var ended = false, frame = 0, canvas = null;
    function finish() {
      if (ended) return; ended = true;
      cancelAnimationFrame(frame);
      removeEventListener('wheel', finish); removeEventListener('touchstart', finish); removeEventListener('keydown', finish);
      done(canvas);
    }
    var decode = img.decode ? img.decode().then(function () { return true; }, function () { return false; }) : Promise.resolve(img.complete);
    Promise.race([decode, new Promise(function (r) { setTimeout(function () { r(false); }, 5000); })]).then(function (ok) {
      if (ended) return;
      if (!ok) { finish(); return; }
      try {
        var size = 300, sample = document.createElement('canvas'); sample.width = sample.height = size;
        var ctx = sample.getContext('2d', { willReadFrequently: true }); ctx.drawImage(img, 0, 0, size, size);
        var px = ctx.getImageData(0, 0, size, size).data, gray = new Float32Array(size * size), min = 255, max = 0;
        for (var i = 0; i < gray.length; i++) { var v = (px[i*4]*.2126 + px[i*4+1]*.7152 + px[i*4+2]*.0722) * (px[i*4+3]/255); gray[i] = v; if (v < min) min = v; if (v > max) max = v; }
        if (max - min < 15) { finish(); return; }
        var th = min + (max - min) * .34;
        var cases = [[],[[3,0]],[[0,1]],[[3,1]],[[1,2]],[[3,0],[1,2]],[[0,2]],[[3,2]],[[2,3]],[[0,2]],[[0,1],[2,3]],[[1,2]],[[1,3]],[[0,1]],[[3,0]],[]];
        var segs = [], nb = new Map(), key = function (p) { return p[0] + p[1] * size * 2; };
        function connect(a, b) { var id = segs.length; segs.push([a, b]); [a, b].forEach(function (p) { var k = key(p); if (!nb.has(k)) nb.set(k, []); nb.get(k).push(id); }); }
        for (var y = 0; y < size - 1; y++) for (var x = 0; x < size - 1; x++) {
          var k = y * size + x, code = (gray[k] > th ? 1 : 0) | (gray[k+1] > th ? 2 : 0) | (gray[k+size+1] > th ? 4 : 0) | (gray[k+size] > th ? 8 : 0);
          if (!code || code === 15) continue;
          var edge = [[x*2+1, y*2], [x*2+2, y*2+1], [x*2+1, y*2+2], [x*2, y*2+1]];
          cases[code].forEach(function (c) { connect(edge[c[0]], edge[c[1]]); });
        }
        var seen = new Uint8Array(segs.length), paths = [];
        for (var s = 0; s < segs.length; s++) {
          if (seen[s]) continue; seen[s] = 1;
          var pts = [segs[s][0], segs[s][1]], end = pts[1];
          while (true) {
            var list = nb.get(key(end)), nx = -1;
            for (var q = 0; q < list.length; q++) if (!seen[list[q]]) { nx = list[q]; break; }
            if (nx < 0) break;
            seen[nx] = 1; var sg = segs[nx]; end = key(sg[0]) === key(end) ? sg[1] : sg[0]; pts.push(end);
          }
          var lens = [], L = 0;
          for (var j = 1; j < pts.length; j++) { var d = Math.hypot(pts[j][0]-pts[j-1][0], pts[j][1]-pts[j-1][1]) / 2; lens.push(d); L += d; }
          if (L > 3) paths.push({ p: pts.map(function (p) { return [p[0]/2, p[1]/2]; }), l: lens, L: L });
        }
        if (!paths.length) { finish(); return; }
        paths.sort(function (a, b) { return b.L - a.L; });
        var lanes = []; for (var n = 0; n < 6; n++) lanes.push({ paths: [], L: 0 });
        paths.forEach(function (p) { var lane = lanes.reduce(function (a, b) { return a.L < b.L ? a : b; }); lane.paths.push(p); lane.L += p.L; });
        canvas = document.createElement('canvas'); canvas.width = canvas.height = 900; canvas.className = 'sgs-trace'; canvas.setAttribute('aria-hidden', 'true'); plate.appendChild(canvas);
        var ink = canvas.getContext('2d'); ink.scale(3, 3); ink.strokeStyle = '#d5ae70'; ink.lineWidth = .68; ink.lineCap = 'round'; ink.lineJoin = 'round';
        addEventListener('wheel', finish, { passive: true }); addEventListener('touchstart', finish, { passive: true }); addEventListener('keydown', finish);
        var start = performance.now();
        function draw(now) {
          if (ended) return;
          var el = now - start, prog = Math.min(1, el / 1950);
          ink.clearRect(0, 0, size, size);
          lanes.forEach(function (lane) {
            var budget = lane.L * prog;
            for (var a = 0; a < lane.paths.length && budget > 0; a++) {
              var path = lane.paths[a]; ink.beginPath(); ink.moveTo(path.p[0][0], path.p[0][1]);
              var rem = Math.min(path.L, budget);
              for (var b = 1; b < path.p.length && rem > 0; b++) { var A = path.p[b-1], B = path.p[b], D = path.l[b-1], t = Math.min(1, rem / D); ink.lineTo(A[0] + (B[0]-A[0]) * t, A[1] + (B[1]-A[1]) * t); rem -= D; }
              ink.stroke(); budget -= path.L;
            }
          });
          if (prog < 1) frame = requestAnimationFrame(draw); else setTimeout(finish, Math.max(0, 2300 - el));
        }
        frame = requestAnimationFrame(draw);
      } catch (e) { finish(); }
    });
    return finish;
  }

  function bootElement(root) {
    var tabs   = root.querySelectorAll('.sgs-sign');
    var head   = root.querySelector('.sgs-head');
    var band   = root.querySelector('.sgs-band');
    var chosen = root.querySelector('.sgs-chosen');
    var plate  = root.querySelector('.sgs-chosen-plate');
    var cImg   = root.querySelector('.sgs-chosen-plate img');
    var cName  = root.querySelector('.sgs-chosen-name');
    var cDates = root.querySelector('.sgs-chosen-dates');
    var change = root.querySelector('.sgs-change');
    if (!chosen || !plate || !cImg) return;
    var cancel = null, timers = [];

    function clearTimers() { timers.forEach(clearTimeout); timers = []; }
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }

    /* The intro, in order:
         trace        plate big and centred, details hidden
         is-drawn     real plate fades in over the trace
         glide        is-intro removed, plate transitions into its slot
         is-settled   only after the glide has finished: details stagger in
       Any interruption jumps straight to the settled state. */
    function playIntro() {
      clearTimers();
      var old = plate.querySelector('canvas'); if (old) old.remove();
      chosen.classList.remove('is-drawn', 'is-settled');
      if (reduced.matches) { chosen.classList.add('is-drawn', 'is-settled'); return; }

      chosen.classList.add('is-intro');
      var rect = plate.getBoundingClientRect();
      var size = Math.min(460, window.innerWidth - 48, window.innerHeight * .58);
      var x = (document.documentElement.clientWidth - size) / 2 - rect.left;
      var y = Math.max(96, (window.innerHeight - size) / 2 - 10) - rect.top;
      plate.style.setProperty('--ix', x + 'px');
      plate.style.setProperty('--iy', y + 'px');
      plate.style.setProperty('--is', String(size / rect.width));

      cancel = trace(plate, cImg, function (canvas) {
        cancel = null;
        chosen.classList.add('is-drawn');
        later(function () { chosen.classList.remove('is-intro'); }, 350);
        later(function () { chosen.classList.add('is-settled'); }, 350 + GLIDE_MS + 60);
        later(function () { if (canvas) canvas.remove(); }, 350 + GLIDE_MS + 700);
      });
    }

    function settleNow() {
      if (cancel) { cancel(); cancel = null; }
      clearTimers();
      var old = plate.querySelector('canvas'); if (old) old.remove();
      chosen.classList.remove('is-intro');
      chosen.classList.add('is-drawn', 'is-settled');
    }

    function open(slug, withIntro) {
      var any = null;
      tabs.forEach(function (t) {
        var on = t.dataset.sign === slug;
        if (on) any = t;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (any) {
        var src = any.querySelector('img').getAttribute('src');
        cName.textContent = any.dataset.name;
        cDates.innerHTML = any.dataset.dates;
        if (head) head.hidden = true;
        if (band) band.hidden = true;
        // Reset to the pre-intro state before the block is shown, so nothing
        // from a previous selection is visible for a frame.
        chosen.classList.remove('is-drawn', 'is-settled', 'is-intro');
        chosen.hidden = false;
        if (cImg.getAttribute('src') !== src) cImg.setAttribute('src', src);
        if (withIntro) {
          try { chosen.scrollIntoView({ block: 'start' }); } catch (e) {}
          requestAnimationFrame(function () { requestAnimationFrame(playIntro); });
        } else {
          settleNow();
        }
      } else {
        settleNow();
        chosen.hidden = true;
        chosen.classList.remove('is-drawn', 'is-settled');
        if (head) head.hidden = false;
        if (band) band.hidden = false;
      }
      try { sessionStorage.setItem('nyt-sign', any ? slug : ''); } catch (e) {}
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { open(t.dataset.sign, true); });
    });
    if (change) change.addEventListener('click', function () {
      open('', false);
      if (head) { try { head.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) {} }
    });

    var wanted = null, fromUrl = false;
    try { wanted = new URLSearchParams(window.location.search).get('sign'); fromUrl = !!wanted; } catch (e) {}
    if (!wanted) { try { wanted = sessionStorage.getItem('nyt-sign'); } catch (e) {} }
    if (wanted && root.querySelector('.sgs-sign[data-sign="' + wanted + '"]')) {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      var back = nav && nav.type === 'back_forward';
      open(wanted, fromUrl && !back);
    }
  }

  function boot() {
    document.querySelectorAll('.sgs[data-hub]').forEach(function (root) {
      if (root.__booted) return; root.__booted = true;
      if (root.dataset.hub === 'true') bootHub(root); else bootElement(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();